import '../../assets/components/Card/Card.css';//#region lib/components/Card/Card.module.css
var e = "_card_12b32_2", t = "_bordered_12b32_10", n = "_title_12b32_16", r = "_divider_12b32_20", i = "_titleSection_12b32_26", a = "_cardBody_12b32_30", o = "_clickable_12b32_35", s = {
	card: e,
	bordered: t,
	title: n,
	divider: r,
	titleSection: i,
	cardBody: a,
	clickable: o
};
//#endregion
export { t as bordered, e as card, a as cardBody, o as clickable, s as default, r as divider, n as title, i as titleSection };
